<template>
  <div class="wk-cascader">
    <template v-if="valueIsObject">
      <el-cascader
        :filterable="filterable"
        v-model="dataValue.select"
        :disabled="disabled"
        :clearable="clearable"
        :placeholder="placeholder"
        :options="options"
        style="width: 100%"
        @change="valueChange"></el-cascader>
    </template>
  </div>
</template>

<script>
import { isObject, isEmpty } from '@/utils/types';
import Emitter from 'element-ui/lib/mixins/emitter';

export default {
  // 自定义字段库 单选
  name: 'WkCascader',

  components: {},

  mixins: [Emitter],

  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterable: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      dataValue: {
        select: [],
        otherValue: [],
      },
    };
  },

  computed: {
    valueIsObject() {
      return isObject(this.dataValue);
    },
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        this.validValue();
      },
      immediate: true,
    },
  },

  created() {
    // this.validValue()
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    /**
     * 验证值
     */
    validValue() {
      if (this.value !== this.dataValue.select && this.value !== this.dataValue.otherValue) {
        if (isEmpty(this.value)) {
          this.dataValue = {
            select: [],
            otherValue: [],
          };
        } else {
          this.dataValue = {
            select: this.value,
            otherValue: '',
          };
        }
      }
    },

    /**
     * 选项值
     */
    getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item;
    },

    /**
     * 判断是空值
     */
    isEmptyValue(value) {
      return value === null || value == undefined;
    },

    /**
     * 值更新
     */
    valueChange() {
      const value = this.dataValue.select === '其他' ? this.dataValue.otherValue.trim() : this.dataValue.select;
      this.$emit('input', value);
      this.$emit('change', value);
      this.dispatch('ElFormItem', 'el.form.change', value);
    },

    /**
     * 失去焦点
     */
    inputBlur() {
      // 暂未加input触发change逻辑
      const value = this.dataValue.otherValue;
      const eIsObject = this.options.length > 0 && !this.isEmptyValue(this.options[0].value);
      const has = this.options.find((item) => {
        if (eIsObject) {
          return item.value === value.trim();
        } else {
          return item === value.trim();
        }
      });
      if (has) {
        this.dataValue.otherValue = [];
      }

      this.$emit('input', this.dataValue.otherValue);
      this.$emit('change', this.dataValue.otherValue);
      this.dispatch('ElFormItem', 'el.form.change', this.dataValue.otherValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.wk-cascader {
  .el-input {
    margin-top: 5px;
  }
}
</style>
